import { render, staticRenderFns } from "./registerSelect.vue?vue&type=template&id=6f19339a&scoped=true&"
import script from "./registerSelect.vue?vue&type=script&lang=js&"
export * from "./registerSelect.vue?vue&type=script&lang=js&"
import style0 from "./registerSelect.vue?vue&type=style&index=0&id=6f19339a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19339a",
  null
  
)

export default component.exports